export const ACCESS_TOKEN_NAME = 'access_token';
export const USER_KEY_STORE = 'user';
